export default __webpack_public_path__ + "static/media/delibuoy.c0496c1b.gif";